// (A) 중립 셀렉트 API — antd 미접촉. (B) PlainSelect(커스텀, Radix Popover 포지셔닝)에 위임.
import type { CSSProperties, MouseEvent, ReactNode } from 'react'
import { PlainSelect } from '../_impl/PlainSelect'

export interface OmwSelectOption<T extends string | number> {
  value: T
  label: ReactNode
  disabled?: boolean
}

/** 선택된 값의 라벨 렌더 인자(→ antd labelRender). */
export interface OmwSelectLabelInfo<T extends string | number> {
  value: T
  label: ReactNode
}

/** 옵션 렌더 부가 정보(→ antd optionRender info). */
export interface OmwSelectOptionInfo {
  index: number
}

/** 테두리 표현(→ antd variant). 실측: editorToolbar borderless. */
export type OmwSelectVariant = 'outlined' | 'borderless' | 'filled'

export interface OmwSelectProps<T extends string | number> {
  value?: T
  defaultValue?: T
  onChange?: (value: T) => void
  options: OmwSelectOption<T>[]
  placeholder?: string
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
  suffixIcon?: ReactNode
  popupClassName?: string
  variant?: OmwSelectVariant
  popupMatchSelectWidth?: boolean
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement
  labelRender?: (info: OmwSelectLabelInfo<T>) => ReactNode
  optionRender?: (option: OmwSelectOption<T>, info: OmwSelectOptionInfo) => ReactNode
  tabIndex?: number
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  className?: string
  style?: CSSProperties
  'data-testid'?: string
  'aria-label'?: string
}

export function OmwSelect<T extends string | number>(props: OmwSelectProps<T>) {
  return <PlainSelect {...props} />
}
